import React from 'react'
import { Grid } from '@the-platform-group/component-library/Layout'

import useSecuritySearch from './hooks/useSecuritySearch'
import SecuritiesSearch from './SecuritiesSearch'
import SecuritiesTable from './SecuritiesTable'

function Securities() {
  const {
    securities,
    isFetching,
    isSaving,
    isDeleting,
    securityOptions,
    setSecurityOptions,
    saveOverride,
    pagination,
    count,
    handlePageChange,
    handlePageSizeChange,
    removeOverride,
  } = useSecuritySearch()
  return (
    <>
      <h1>Security Overrides</h1>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SecuritiesSearch value={securityOptions} setSecurityOptions={setSecurityOptions} />
        </Grid>
        <Grid item xs={12}>
          <SecuritiesTable
            securities={securities}
            isLoading={isFetching}
            isSaving={isSaving}
            isDeleting={isDeleting}
            saveOverride={saveOverride}
            pagination={pagination}
            count={count}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            removeOverride={removeOverride}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Securities
